import type { MediaCategory, MediaVideo } from '@/types/media'
import { PATHS } from '@/routes/paths'
import { absoluteUrl, cleanSeoText, truncateMetaDescription, uniqueKeywords } from '../utils'
import { breadcrumbSchema } from '../schemas/common'

export function buildMediaListSeo() {
  return {
    title: 'Property Insights & Video Reels | QBC Media Center',
    description: truncateMetaDescription(
      'Watch expert property advice, market updates, builder interviews and investment tips from Quick Build Con.',
    ),
    keywords: uniqueKeywords([
      'property videos',
      'real estate reels',
      'property tips india',
      'qbc media',
      'instagram reels property',
    ]),
    canonical: absoluteUrl(PATHS.media),
  }
}

export function buildMediaDetailSeo(video: MediaVideo) {
  const description = truncateMetaDescription(
    video.shortDescription || cleanSeoText(video.title),
  )

  return {
    title: `${video.title} | QBC Media Center`,
    description,
    keywords: uniqueKeywords([
      video.category?.name,
      video.platform,
      'property video',
      'Quick Build Con',
    ]),
    canonical: absoluteUrl(PATHS.mediaDetail(video.slug)),
    ogImage: video.thumbnail || undefined,
    ogType: 'video.other',
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: video.title,
        description,
        thumbnailUrl: video.thumbnail,
        uploadDate: video.publishedAt || undefined,
        embedUrl: video.embedUrl || video.socialUrl,
        contentUrl: video.socialUrl,
      },
      breadcrumbSchema([
        { name: 'Home', url: PATHS.home },
        { name: 'Media', url: PATHS.media },
        { name: video.title, url: PATHS.mediaDetail(video.slug) },
      ]),
    ],
  }
}

export function buildMediaCategorySeo(category: MediaCategory) {
  return {
    title: `${category.name} Videos | QBC Media Center`,
    description: truncateMetaDescription(
      `Browse ${category.name} videos — property insights and expert advice from Quick Build Con.`,
    ),
    keywords: uniqueKeywords([category.name.toLowerCase(), 'property videos', 'qbc media']),
    canonical: absoluteUrl(`${PATHS.media}?category=${category.slug}`),
  }
}
